var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.item.media
    ? _c("div", { staticClass: "chap-editor" }, [
        _c("h3", [_vm._v("Chapters")]),
        _vm._v(" "),
        _c(
          "a",
          {
            staticClass: "new-chapter",
            attrs: { href: "" },
            on: {
              click: function($event) {
                $event.preventDefault()
                return _vm.add($event)
              }
            }
          },
          [_vm._v("+")]
        ),
        _vm._v(" "),
        _vm.item.chapters
          ? _c(
              "ul",
              _vm._l(_vm.item.chapters, function(chapter, ci) {
                return _c("li", [
                  _c("span", [_vm._v(_vm._s(_vm.formatTime(chapter.time)))]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: chapter.title,
                        expression: "chapter.title"
                      }
                    ],
                    attrs: { type: "text" },
                    domProps: { value: chapter.title },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(chapter, "title", $event.target.value)
                      }
                    }
                  }),
                  _vm._v(" "),
                  chapter.time
                    ? _c(
                        "a",
                        {
                          staticClass: "remove",
                          attrs: { href: "" },
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.remove(ci)
                            }
                          }
                        },
                        [_vm._v("×")]
                      )
                    : _vm._e()
                ])
              }),
              0
            )
          : _vm._e()
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }